import { render, staticRenderFns } from "./TransactionNotifications.vue?vue&type=template&id=000c6287"
import script from "./TransactionNotifications.vue?vue&type=script&lang=js"
export * from "./TransactionNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports